import { Grid, Typography } from "@material-ui/core";
import React from "react";
import "./Header.css";
import { useHistory } from "react-router-dom";

function Header() {
  const history = useHistory();

  return (
    <div className="header">
      <div className="max-widths">
        <Grid container className="grid" spacing={2}>
          <Grid item xs={12} md={6} lg={6} xl={6}>
            <div className="left">
              <Typography className="logo">
                IT-<span>ຕາຂຽວ</span>
              </Typography>
            </div>
          </Grid>
          <Grid item xs={12} md={6} lg={6} xl={6}>
            <div className="right">
              <Typography className="menu" onClick={() => history.push("/")}>
                Home
              </Typography>
              <Typography
                className="menu"
                onClick={() => history.push("/register")}
              >
                Register
              </Typography>
              <Typography
                className="menu"
                onClick={() => history.push("/login")}
              >
                LogIn
              </Typography>
              <Typography className="menu" onClick={() => history.push("/")}>
                LogOut
              </Typography>
            </div> 
          </Grid>
        </Grid>
      </div>
    </div>
  );
}

export default Header;
